import React from 'react';
import Menu from "../../Components/Menu/Menu";
import './ConnectionError.css';

const ConnectionError = () => {
    return (
        <div className={'connection-err-container'}>
            <Menu />
            <div className={'connection-err-icon-text'}>
                <div className={'connection-err-icon'}></div>
                <div className={'connection-err-text'}>Нет соединения, возможно ошибка сети.</div>
            </div>
            <div className={'connection-err-bg'}></div>
        </div>
    );
};

export default ConnectionError;
